import { Typography } from '@percent/lemonade'
import { VerificationNotificationTextProps } from './NotificationBarText.types'
import styles from './NotificationBar.module.scss'

export const VerificationNotificationText = ({
  notificationText,
  buttonText,
  buttonUrl,
  onButtonClick,
  showApplicationStatus
}: VerificationNotificationTextProps) => {
  return (
    <Typography data-testid="verification-notification-text">
      {notificationText}{' '}
      {buttonText &&
        (showApplicationStatus ? (
          <button className={styles.openModal} data-testid="go-to-my-discounts-button" onClick={onButtonClick}>
            {buttonText}
          </button>
        ) : (
          <a data-testid="contact-us-link" href={buttonUrl} target="_blank" rel="noreferrer">
            {buttonText}.
          </a>
        ))}
    </Typography>
  )
}
